import _ from 'lodash';
import produce from 'immer';

import { localStorageClient } from '../storage/wrapper';

import { ADMINISTRATION_DEBUG_MODE_TOGGLE, DEBUG_MODE_KEY } from './administration.actions';

const debugModeValue = localStorageClient.getItemAndParse(DEBUG_MODE_KEY);

const defaultState = {
  debug: {
    isDebugModeEnabled: debugModeValue,
  },
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case ADMINISTRATION_DEBUG_MODE_TOGGLE: {
      draft.debug.isDebugModeEnabled = !draft.debug.isDebugModeEnabled;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
